
// HELPERS
//---------------------------------------


// Makes sure last grid item floats left
jQuery('.archive-grid .columns').last().addClass('end');

// page-sub-nav - add active to current page link
jQuery(function($) {
    var path = window.location.href; // because the 'href' property of the DOM element is the absolute path
    $('ul.page-sub-nav li a').each(function() {
        if (this.href === path) {
            $(this).addClass('active');
        }
    });
});


// PAGE FLEXIBLE 
// WRAPS IN A ROW-CONTAINER flexible elements inside .free-column class and outside a ROW  
// jQuery(".free-column .large-12").wrapAll("<div class='row container' />");
// jQuery(".free-column .large-9").wrapAll("<div class='row container' />");
// jQuery(".free-column .large-6").wrapAll("<div class='row container' />");
// jQuery(".free-column .large-4").wrapAll("<div class='row container' />");
// jQuery(".free-column .large-3").wrapAll("<div class='row container' />");

//jQuery(".free-column").wrapAll("<div class='row' />");
//jQuery(".free-column").wrapAll("<div class='row jsadded' />");


// flex featured item, add class to even for zig-zag

$(".editorimage:even .img-col").addClass('large-push-6');
$(".editorimage:even .editor-col").addClass('large-pull-6');

$(".galleryeditor:even .img-col").addClass('large-push-6');
$(".galleryeditor:even .editor-col").addClass('large-pull-6');

// $(".featured_item:even .img-col").addClass('large-push-6');
// $(".featured_item:even .text-col").addClass('large-pull-5');


// add line botton in H1 of all inner pages heros
// jQuery("body:not(.home) .hero-section-text h1").wrapAll("<div class='title-line-bottom jsadded' />");

jQuery(".hero-section-text .button").wrapAll("<div class='hero-button-group jsadded' />");

// add line botton in STRONG words within a title
jQuery(".hero-section-text h1, .hero-section-text .hero").wrapAll("<div class='word-line-bottom jsadded' />");

jQuery(".hero_full h1").addClass('hero');

// cta button on header
$("li.cta").addClass('button large');
